module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// /Users/thiago/Documents/projetos/biblioteco-angular/src/assets/global/plugins/bootstrap/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/global/plugins/bootstrap/fonts/bootstrap/glyphicons-halflings-regular.svg
// module chunks = styles